import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

/**
 * Provider unique du thème StaffDesk — monté une seule fois, dans `main.jsx`,
 * au-dessus de l'app (et hors du `StyledEngineProvider injectFirst` du
 * DatePicker calendrier, qui préserve son ordre d'injection CSS).
 */
export function StaffDeskThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

StaffDeskThemeProvider.propTypes = { children: PropTypes.node };
